// extracted by mini-css-extract-plugin
export default {"experience":"OuozWylgEkPv9F1dmYeP","content":"XmPjufAn6b8NeU2hpODj","infoNote":"wPm2N231XEctOOezioHO","experienceContainer":"ba042nUr4SwYDw1wIhfJ"};